<template>
  <div class="pagination-container">
    <button
      v-bind:disabled="currentPage === 1"
      v-on:click="switchPage(currentPage - 1)"
    >
      <img src="../assets/images/left-chevron.svg" alt="direction icon"/>
    </button>

    <div
      v-for="number in arrayOfPages"
      v-bind:key="number"
    >
      <button
        v-bind:class="{activeButton:currentPage === number}"
        v-on:click="switchPage(number)"
      >
        {{number}}
      </button>
    </div>

    <button
      v-bind:disabled="Math.ceil(totalJobs/itemsPerPage) === currentPage"
      v-on:click="switchPage(currentPage + 1)"
    >
      <img src="../assets/images/right-chevron.svg" alt="direction icon"/>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props:[
    'itemsPerPage',
    'totalJobs',
    'currentPage'
  ],
  data(){
    return{
      pageNumbers:[],
    };
  },
  methods:{
    switchPage(pageNumber){
      this.$emit('paginate', pageNumber);
    },
    numberOfPages(){
      this.pageNumbers = [];
      for(let i = 1; i <= Math.ceil(this.totalJobs/this.itemsPerPage); ++i){
        this.pageNumbers.push(i);
      }
      return this.pageNumbers;
    }
  },
  computed: {
    arrayOfPages(){
      return this.numberOfPages();
    }
  }
};
</script>

<style scoped>
  .pagination-container {
    display:flex;
  }

  .pagination-container button {
    width: 60px;
    height:60px;
    background: var(--white);
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    border-radius: 3px;
    border:none;
    margin-left: 15px;
    display:flex;
    justify-content:center;
    align-items:center;
    font-size:18px;
  }

  button.activeButton {
    background:var(--colorPrimary);
    color:var(--white);
  }

  .pagination-container img {
    width:18px;
    height:18px;
  }


  @media only screen and (max-width:1178px) {

  }

  @media only screen and (max-width:1078px) {

  }

  @media only screen and (max-width:990px) {

  }

  @media only screen and (max-width: 767px) {

  }

  @media only screen and (max-width: 565px) {

  }

  @media only screen and (max-width: 420px) {

  }
</style>
